import { render } from "./CertificatePage.vue?vue&type=template&id=5dbf417a"
import script from "./CertificatePage.vue?vue&type=script&lang=js"
export * from "./CertificatePage.vue?vue&type=script&lang=js"

import "./CertificatePage.vue?vue&type=style&index=0&id=5dbf417a&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__